import * as React from 'react'
import classNames from 'classnames'
import { Lazy } from '../../../app-core/lib/ui/Lazy'

type TProps = {
    onClick?: () => void
    type?: string
}

export function TodoItem(props: React.PropsWithChildren<TProps>) {
    const isScheduledType = props.type === 'scheduled'
    const isDoneType = props.type === 'done'
    return (
        <Lazy
            placeholder={
                <div
                    className={classNames('AppCore__ui__TodoItem', 'lazy-loading', {
                        Scheduled_Item: isScheduledType,
                        Done_Item: isDoneType,
                    })}
                    onClick={props.onClick}
                />
            }
            render={() => (
                <div
                    className={classNames('AppCore__ui__TodoItem', {
                        'AppCore__ui__TodoItem-clickable': Boolean(props.onClick),
                        Scheduled_Item: isScheduledType,
                        Done_Item: isDoneType,
                    })}
                    onClick={props.onClick}
                >
                    {props.children}
                </div>
            )}
        />
    )
}
